import { Outlet } from "@tanstack/react-router";
import clsx from "clsx";
import { useMemo } from "react";
import { useUserName } from "src/datahandling/hooks";
import { useSessionStorage } from "usehooks-ts";
import { Header } from "./header";
import { RootPageContext } from "./RootPage.context";
import styling from "./RootPage.module.scss";
import { SideMenu } from "./side-menu";
import { Flex } from "@scaleaq/sui-react";

export const RootPage = () => {
	// *****************************************
	// Properties
	// *****************************************

	const username = useUserName();

	// *****************************************
	// Lifecycle
	// *****************************************

	const [sideMenuOpen, setSideMenuOpen] = useSessionStorage<boolean>("side-menu-open", false);

	// *****************************************
	// Render
	// *****************************************

	const context = useMemo(() => {
		return {
			username,
			sideMenuOpen,
			setSideMenuOpen,
			logout: () => {},
		};
	}, [sideMenuOpen, username, setSideMenuOpen]);

	return (
		<RootPageContext.Provider value={context}>
			{sideMenuOpen && <SideMenu />}
			<Flex.Column
				alignment="top-left"
				width="stretch"
				className={clsx(styling.content, {
					[styling["content--with-side-menu"]]: sideMenuOpen,
				})}
			>
				<Header />
				<Flex.Column
					render={<main />}
					alignment="top-left"
					width="100%"
					className={clsx(styling.main, {
						[styling["main--with-side-menu"]]: sideMenuOpen,
					})}
				>
					<Outlet />
				</Flex.Column>
			</Flex.Column>
		</RootPageContext.Provider>
	);
};
